import { MAIL_FUNCTION_URL } from './siteConfig'; 

///export const mailUrl = MAIL_FUNCTION_URL+'/mailFunctions';
export const mailUrl = MAIL_FUNCTION_URL;
